import { useMemo } from 'react';
import { getT, type Catalogue, type Namespace, type Translate } from './core';
import { useLocale } from './locale';

/**
 * `const t = useT(messages)` → `t('title')`, `t('days', { count: 3 })`, `t.rich('terms', { link: (c) => <a>{c}</a> })`.
 * The component re-renders when the language changes.
 */
export function useT<C extends Catalogue>(ns: Namespace<C>): Translate<C> {
  const locale = useLocale();
  return useMemo(() => getT(ns, locale), [ns, locale]);
}
